declare namespace $ {

	type $mol_view__sub_bog_music_playlists_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__attr_bog_music_playlists_2 = $mol_type_enforce<
		({ 
			'bog_music_playlists_current': ReturnType< $bog_music_playlists['my_current'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_button_minor__click_bog_music_playlists_3 = $mol_type_enforce<
		ReturnType< $bog_music_playlists['my_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_music_playlists_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $bog_music_select__hint_bog_music_playlists_5 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_music_select['hint'] >
	>
	type $bog_music_select__value_bog_music_playlists_6 = $mol_type_enforce<
		ReturnType< $bog_music_playlists['list_current'] >
		,
		ReturnType< $bog_music_select['value'] >
	>
	type $bog_music_select__dictionary_bog_music_playlists_7 = $mol_type_enforce<
		ReturnType< $bog_music_playlists['list_dict'] >
		,
		ReturnType< $bog_music_select['dictionary'] >
	>
	type $bog_music_select__option_label_default_bog_music_playlists_8 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_music_select['option_label_default'] >
	>
	type $bog_music_select__no_options_message_bog_music_playlists_9 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_music_select['no_options_message'] >
	>
	type $bog_music_select__Trigger_icon_bog_music_playlists_10 = $mol_type_enforce<
		ReturnType< $bog_music_playlists['List_icon'] >
		,
		ReturnType< $bog_music_select['Trigger_icon'] >
	>
	type $mol_button_minor__hint_bog_music_playlists_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_music_playlists_12 = $mol_type_enforce<
		ReturnType< $bog_music_playlists['add_toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_music_playlists_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_string__hint_bog_music_playlists_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_music_playlists_15 = $mol_type_enforce<
		ReturnType< $bog_music_playlists['add_title'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_bog_music_playlists_16 = $mol_type_enforce<
		ReturnType< $bog_music_playlists['add_submit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__enter_bog_music_playlists_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['enter'] >
	>
	type $mol_button_major__title_bog_music_playlists_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_music_playlists_19 = $mol_type_enforce<
		ReturnType< $bog_music_playlists['add_submit'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_view__sub_bog_music_playlists_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_string__hint_bog_music_playlists_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_music_playlists_22 = $mol_type_enforce<
		ReturnType< $bog_music_playlists['rename_title'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_bog_music_playlists_23 = $mol_type_enforce<
		ReturnType< $bog_music_playlists['rename_submit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__enter_bog_music_playlists_24 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['enter'] >
	>
	type $mol_view__sub_bog_music_playlists_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_bog_music_playlists_26 = $mol_type_enforce<
		ReturnType< $bog_music_playlists['remove_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_music_playlists_27 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_music_playlists_28 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_pop__align_bog_music_playlists_29 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pop['align'] >
	>
	type $mol_pop__Anchor_bog_music_playlists_30 = $mol_type_enforce<
		ReturnType< $bog_music_playlists['Add_anchor'] >
		,
		ReturnType< $mol_pop['Anchor'] >
	>
	type $mol_pop__bubble_content_bog_music_playlists_31 = $mol_type_enforce<
		ReturnType< $bog_music_playlists['add_content'] >
		,
		ReturnType< $mol_pop['bubble_content'] >
	>
	type $mol_view__attr_bog_music_playlists_32 = $mol_type_enforce<
		({ 
			'bog_music_playlists_current': ReturnType< $bog_music_playlists['list_active'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_bog_music_playlists_33 = $mol_type_enforce<
		ReturnType< $bog_music_playlists['middle'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_music_playlists_34 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__attr_bog_music_playlists_35 = $mol_type_enforce<
		({ 
			'bog_music_playlists_current': ReturnType< $bog_music_playlists['archive_current'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_button_minor__click_bog_music_playlists_36 = $mol_type_enforce<
		ReturnType< $bog_music_playlists['archive_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_music_playlists_37 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	export class $bog_music_playlists extends $mol_view {
		my_current( ): boolean
		my_click( next?: any ): any
		My_label( ): $mol_view
		My( ): $mol_button_minor
		list_active( ): boolean
		list_current( next?: string ): string
		List_icon( ): $mol_icon_chevron_down
		List( ): $bog_music_select
		add_toggle( next?: any ): any
		Add_icon( ): $mol_icon_plus
		Add_anchor( ): $mol_button_minor
		add_title( next?: string ): string
		add_submit( next?: any ): any
		Add_title( ): $mol_string
		Add_submit( ): $mol_button_major
		Add_panel( ): $mol_view
		rename_title( next?: string ): string
		rename_submit( next?: any ): any
		Rename( ): $mol_string
		remove_click( next?: any ): any
		Remove_icon( ): $mol_icon_delete
		remove_label( ): string
		Remove_label( ): $mol_view
		Remove( ): $mol_button_minor
		Edit_panel( ): $mol_view
		add_content( ): readonly(any)[]
		Add( ): $mol_pop
		middle( ): readonly(any)[]
		Middle( ): $mol_view
		archive_current( ): boolean
		archive_click( next?: any ): any
		Archive_label( ): $mol_view
		Archive( ): $mol_button_minor
		page( next?: string ): string
		my_title( ): string
		archive_title( ): string
		list_dict( ): Record<string, any>
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=playlists.view.tree.d.ts.map